import styled from "styled-components";

export const DashboardWrapper = styled.div`
  padding: 2% 5%;
`;
